import React, { FC } from 'react';
import cn from 'classnames';
import './styles.scss';

interface IDetailsItem {
  altContent?: JSX.Element;
  className?: string;
  content: string | JSX.Element;
  label: string | JSX.Element;
}

interface IDetailsContainer {
  className?: string;
  divider?: boolean;
  items: IDetailsItem[];
  title?: string;
  containerRef?: React.MutableRefObject<HTMLDivElement | null>
}

const DetailsContainer: FC<IDetailsContainer> = ({ className, divider, items, title, containerRef }) => {
  return (
    <>
      {title ? <h3 className='hbh-details-title'>{title}</h3> : null}
      <div ref={containerRef} className={cn('hbh-details-container', className)}>
        {items.map((item, i) => (
          <div className={cn('hbh-details-item', item.className)} key={i}>
            {item.altContent ? (
              item.altContent
            ) : (
              <>
                <div className='hbh-details-item-label'>{item.label}</div>
                <div className='hbh-details-item-value'>{item.content}</div>
              </>
            )}
          </div>
        ))}
      </div>
      {divider ? <hr className='hbh-details-divider' /> : null}
    </>
  );
};

export default DetailsContainer;
